import api from '@/services/Api'

export default {
    view (balanceTransactionId) {
        return api().get(`/stripe/balanceTransactions/${balanceTransactionId}`)
    },
}
